import { useEffect, useState } from "react";
import { apiRequest, catchErrorMessageHandler } from "../../infrastructure/backendService";
import apiPath from "../../config/apiPaths.json";
import toast from "react-hot-toast";
import ErrorPopup from "../common/ErrorPopup";
import constants from "../../config/constants.json";
import HallBookingRequest from "./hallBookingRequest";

export const initialState :HallBookingRequest= {
    hallBookingRequestId: 0,
    contractFormId: 0,
    devoteeUsername: "",
    devoteeFullname: "",
    devoteeInitials: "",
    email: "",
    address: "",
    city: "",
    state: "",
    country: "",
    zipcode: "",
    phoneNumber: "",
    alternatePhoneNumber: "",
    eventHallChargesBreakdown: [
      {
        eventHallId: 0,
        eventHallName: "",
        eventDate: "",
        eventStartTime: "",
        eventEndTime: "",
        eventDuration: 0,
        hourlyFee: 0,
        securityDeposit: 0,
        totalAmount: 0,
        facilityUsageReservationFee: null,
        furnitureSetupBreakdownCleaningFee: 0
      }
    ],
    eventHallOtherCharges: [
      {
        feeCategory: "",
        duration: 0,
        hourlyFee: 0
      },
      {
        feeCategory: "",
        duration: 0,
        hourlyFee: 0
      },
      {
        feeCategory: "",
        duration: 0,
        hourlyFee: 0
      },
      {
        feeCategory: "",
        duration: 0,
        hourlyFee: 0
      },
      {
        feeCategory: "",
        duration: 0,
        hourlyFee: 0
      },
      {
        feeCategory: "",
        duration: 0,
        hourlyFee: 0
      }
    ],
    eventDate: "",
    eventStartTime: "",
    eventEndTime: "",
    eventDuration: 0,
    eventGuestCount: 0,
    eventNature: "",
    agreementExecutionDate: "",
    devoteeAcknowledgedTermsConditions: true,
    devoteeAcknowledgedTermsConditionsDate: "",
    managerUsername: "",
    managerFullname: "",
    managerPhoneNumber: "",
    managerAcknowledgedAuthorityToSign: true,
    managerAcknowledgedAuthorityToSignDate: "",
    facilityUsageReservationFee: 0,
    furnitureSetupBreakdownCleaningFee: 0,
    securityDeposit: 0,
    initialAmountToPay: 0,
    finalAmountToPay: 0,
    securityDepositPaid: null,
    initialAmountPaid: true,
    finalAmountPaid: true,
    devoteeSignature: "",
    devoteeAcknowledgedAgreement: true,
    devoteeAgreementSignedDate: "",
    statusCode: "",
    status: "",
    eventRequiredRoomsCount: null,
    contractFormTransactions: [
      {
        referenceNumber: "",
        dateOfTransaction: "",
        amountTransacted: 0
      },
      {
        referenceNumber: "",
        dateOfTransaction: "",
        amountTransacted: 0
      },
      {
        referenceNumber: "",
        dateOfTransaction: "",
        amountTransacted: 0
      }
    ],
    receiptId: 0
  };
  

function useSharedState(rowDataId:number,hallContractFormId:number,status:string):HallBookingRequest {
    const [sharedState, setSharedState] = useState<HallBookingRequest>(initialState);
    const [isOpen, setIsOpen] = useState<boolean>(false);
  
    useEffect(()=>{
        if (rowDataId!=0 &&  hallContractFormId!=0) {
            apiRequest({
              method: "GET",
              endpoint: `${apiPath.contractFormHallBookingManagerFlow}/${rowDataId}/contracts/${hallContractFormId}`,
              includeToken: true,
            })
              .then((res) => {
                console.log(res.data);
                setSharedState(res.data);
              })
              .catch((err) => {
                console.log(err);
                toast.custom(
                  <ErrorPopup
                    showMessage={catchErrorMessageHandler(err)}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                  />,
                  {
                    duration: constants.TOAST_POPUP_DURATION,
                  }
                );
              });
          }
    },[rowDataId,hallContractFormId]);
    
    return sharedState ;
  }

  export default useSharedState;